/**
 * Calculates the difference in days between two dates.
 * @param {Date} a The first date.
 * @param {Date} b The second date.
 * @returns {number} The number of days between the two dates.
 */
export const daysDifference = (a: Date, b: Date): number => {
	if (!a || !b || a.getTime() === 0 || b.getTime() === 0) {
		return null;
	}

	const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;

	const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
	const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

	return Math.floor((utc2 - utc1) / MILLISECONDS_PER_DAY);
};
